import { useContext, useEffect, useState, useRef } from "react";
import FormContext from "../../context/FormContext.js";
import StaticDataContext from "../../context/StaticDataContext.js";
import { InputField as Input, FormSection as Section, RowField as Row, FormContainer as Container } from "../../components/";
import { useInjectFormProps } from "../../hooks/useInjectInputs.js";
import { createList } from "../../utils/utils.js";
import { FORM_FIELDS } from "../../utils/constants.js";

export default function EnrollmentInfoPage() {
    const { formData, updateFormData } = useContext(FormContext);
    const { staticData } = useContext(StaticDataContext);
    const { injectFormProps } = useInjectFormProps();

    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];

    today.setFullYear(today.getFullYear() - 1);
    const minDOB = today.toISOString().split("T")[0];

    const [gradeList, setGradeList] = useState([]);
    const createGradesBySchool = (schoolCode) => {
        const selectedSchool = staticData.schools.find((school) => school.Code === schoolCode);
        if (!selectedSchool) {
            console.warn(`No school found for code: ${schoolCode}`);
            setGradeList([]);
            return;
        }

        const startGrade = selectedSchool.Start_Grade;
        const numOfGrades = selectedSchool.Number_Of_Grades;
        let grades = [];
        let currGrade = startGrade;
        for (let i = 0; i < numOfGrades; i++) {
            grades.push({
                value: staticData.gradeLevels.find((gradeLevel) => Number(gradeLevel.Numeric_Level) === Number(currGrade)).Code,
                label: staticData.gradeLevels.find((gradeLevel) => Number(gradeLevel.Numeric_Level) === Number(currGrade)).Description,
            });
            currGrade++;
        }

        setGradeList(grades);
    };

    useEffect(() => {
        if (formData[FORM_FIELDS.SCHOOL_RECEIVING]) {
            createGradesBySchool(formData[FORM_FIELDS.SCHOOL_RECEIVING]);
        }
    }, [formData[FORM_FIELDS.SCHOOL_RECEIVING]]);

    return (
        <Container>
            {injectFormProps(
                <>
                    <Section title={"Enrollment Information"}>
                        <Row>
                            <Input
                                type="select"
                                inputLabel={"School Receiving Application"}
                                identifier={FORM_FIELDS.SCHOOL_RECEIVING}
                                options={createList(staticData, "schools", { Active: "1", ...(formData["isRegPrek"] === "1" && { Start_Grade: "-1" }) }, "Code", "School_Name", undefined, "School_Name")}
                                disabled={formData[FORM_FIELDS.WORKING_WITH_SWIS] === "1" && formData[FORM_FIELDS.IS_CAN_CIT] === "0"}
                                hint={formData["isRegPrek"] === "1"
                                    && "By choosing 'Registering PreK student' at the start, only schools that offer PreK will be available for selection'"}
                            />
                            <Input
                                type="date"
                                inputLabel={"Entry Date to this School"}
                                identifier={FORM_FIELDS.ENTRY_DATE}
                                minDate={formattedDate}
                            />
                            <Input type="select" inputLabel={"Grade"} identifier={FORM_FIELDS.GRADE} options={formData["isRegPrek"] === "1" ? [{ value: "PK", label: "PreKindergarten" }] : gradeList}
                                defaultOption={(gradeList.length > 0 ? undefined : "Please select school first")} />
                        </Row>
                        <hr />
                        <b>
                            <i>
                                To locate the school within your area, click{" "}
                                <a href="https://transportation.gssd.ca/Eligibility" target="_blank" rel="noreferrer">
                                    here
                                </a>{" "}
                                to access our school locator.
                            </i>
                        </b>
                        <hr />
                        <Input
                            type="noyesradio"
                            inputLabel={"Is English the only language spoken at home?"}
                            identifier={FORM_FIELDS.IS_HOME_ENGLISH_ONLY}
                        />
                        <Input
                            type="noyesradio"
                            inputLabel={"Is the student an Exchange Student?"}
                            identifier={FORM_FIELDS.IS_EXCHANGE_STUDENT}
                        />
                        {
                            formData[FORM_FIELDS.IS_EXCHANGE_STUDENT] === "1" &&
                            <Input type="text" inputLabel={"Please provide the name of Exchange Program"} identifier={FORM_FIELDS.EXCHANGE_PROGRAM_NAME} />
                        }
                        <Input
                            type="noyesradio"
                            inputLabel={"Do you require bus transportation?"}
                            identifier={FORM_FIELDS.IS_BUS_REQUIRED}
                        />

                        {(formData[FORM_FIELDS.GRADE] === "01" || formData[FORM_FIELDS.GRADE] === "0K" || formData[FORM_FIELDS.GRADE] === "PK") &&
                            <>
                                <Input
                                    type="noyesradio"
                                    inputLabel={"Does the student have previous schooling?"}
                                    identifier={FORM_FIELDS.HAS_PREVIOUS_SCHOOL}
                                />
                                {(formData[FORM_FIELDS.HAS_PREVIOUS_SCHOOL] === "1")
                                    && (
                                        <>
                                            <Input
                                                type="noyesradio"
                                                inputLabel={"Is the student transferring from another school within Good Spirit School Division?"}
                                                identifier={FORM_FIELDS.IS_TRANSFERING_WITHIN}
                                            />
                                            {formData[FORM_FIELDS.IS_TRANSFERING_WITHIN] === "0" && (
                                                <>
                                                    <Input type="text" inputLabel={"Origin School (Last School Attended)"} identifier={FORM_FIELDS.ORIGIN_SCHOOL} />
                                                    <Row>
                                                        <Input type="text" inputLabel={"City"} identifier={FORM_FIELDS.ORIGIN_SCHOOL_CITY} />
                                                        <Input type="select" inputLabel={"Country"} identifier={FORM_FIELDS.ORIGIN_SCHOOL_COUNTRY} options={createList(staticData, "countries", [])} />
                                                        {
                                                            formData[FORM_FIELDS.ORIGIN_SCHOOL_COUNTRY] === "CA"
                                                                ? <Input type="select" inputLabel={"Province"} identifier={FORM_FIELDS.ORIGIN_SCHOOL_PROVINCE} options={createList(staticData, "province", [])} />
                                                                : <Input type="text" inputLabel={"State or Province"} identifier={FORM_FIELDS.ORIGIN_SCHOOL_PROVINCE} />
                                                        }                                                    </Row>
                                                </>
                                            )}
                                            {formData[FORM_FIELDS.IS_TRANSFERING_WITHIN] === "1" && (
                                                <Input type="select" inputLabel={"Origin School"} identifier={FORM_FIELDS.ORIGIN_SCHOOL} options={createList(staticData, "schools", { Active: "1" }, "Code", "School_Name", undefined, "School_Name")}
                                                />
                                            )}
                                        </>
                                    )
                                }
                            </>
                        }
                        {(formData[FORM_FIELDS.GRADE] !== "01" && formData[FORM_FIELDS.GRADE] !== "0K" && formData[FORM_FIELDS.GRADE] !== "PK")
                            && (
                                <>
                                    <Input
                                        type="noyesradio"
                                        inputLabel={"Is the student transferring from another school within Good Spirit School Division?"}
                                        identifier={FORM_FIELDS.IS_TRANSFERING_WITHIN}
                                    />
                                    {formData[FORM_FIELDS.IS_TRANSFERING_WITHIN] === "0" && (
                                        <>
                                            <Input type="text" inputLabel={"Origin School (Last School Attended)"} identifier={FORM_FIELDS.ORIGIN_SCHOOL} />
                                            <Row>
                                                <Input type="text" inputLabel={"City"} identifier={FORM_FIELDS.ORIGIN_SCHOOL_CITY} />
                                                <Input type="select" inputLabel={"Country"} identifier={FORM_FIELDS.ORIGIN_SCHOOL_COUNTRY} options={createList(staticData, "countries", [])} />
                                                {
                                                    formData[FORM_FIELDS.ORIGIN_SCHOOL_COUNTRY] === "CA"
                                                        ? <Input type="select" inputLabel={"Province"} identifier={FORM_FIELDS.ORIGIN_SCHOOL_PROVINCE} options={createList(staticData, "province", [])} />
                                                        : <Input type="text" inputLabel={"State or Province"} identifier={FORM_FIELDS.ORIGIN_SCHOOL_PROVINCE} />
                                                }
                                            </Row>
                                        </>
                                    )}
                                    {formData[FORM_FIELDS.IS_TRANSFERING_WITHIN] === "1" && (
                                        <Input type="select" inputLabel={"Origin School"} identifier={FORM_FIELDS.ORIGIN_SCHOOL} options={createList(staticData, "schools", [], "Code", "School_Name")} />
                                    )}
                                </>
                            )
                        }
                        {(formData[FORM_FIELDS.GRADE] >= 10 && formData[FORM_FIELDS.GRADE] < 13) && (
                            <>
                                <Input
                                    type="noyesradio"
                                    inputLabel={"Is the student here for hockey?"}
                                    identifier={FORM_FIELDS.IS_HERE_HOCKEY}
                                />
                                {formData[FORM_FIELDS.IS_HERE_HOCKEY] === "1" && (
                                    <Input
                                        type="text"
                                        inputLabel={"Please provide the team name:"}
                                        identifier={FORM_FIELDS.HOCKEY_TEAM_NAME}
                                    />
                                )}
                            </>
                        )}

                        {(formData[FORM_FIELDS.GRADE] >= 10 && formData[FORM_FIELDS.GRADE] < 13 && formData[FORM_FIELDS.SCHOOL_RECEIVING] === "MCS") && (
                            <Input
                                type="noyesradio"
                                inputLabel={"Is student registering for French Immersion?"}
                                identifier={"isFrenchImmersion"}
                            />
                        )}
                    </Section>
                    <hr />
                    <Section title={"Student Information"}>
                        <Row>
                            <Input type="text" inputLabel={"First Name"} identifier={FORM_FIELDS.STUDENT_FIRST_NAME} />
                            <Input type="text" inputLabel={"Last Name"} identifier={FORM_FIELDS.STUDENT_LAST_NAME} />
                            <Input type="text" inputLabel={"Middle Name"} identifier={FORM_FIELDS.STUDENT_MIDDLE_NAME} mandatory={false} />
                            <Input type="select" inputLabel={"Legal Suffix"} identifier={FORM_FIELDS.STUDENT_LEGAL_SUFFIX} mandatory={false} options={createList(staticData, "suffix")} />
                        </Row>
                        <Input type="noyesradio" inputLabel={"Does the student have a preferred name?(if different from legal name)"} identifier={"hasPreferredName"} />
                        {formData["hasPreferredName"] === '1' &&
                            <Row>
                                <Input type="text" inputLabel={"Preferred First Name"} identifier={"studentPrefFirstName"} mandatory={false} />
                                <Input type="text" inputLabel={"Preferred Last Name"} identifier={"studentPrefLastName"} mandatory={false} />
                                <Input type="text" inputLabel={"Preferred Middle Name"} identifier={"studentPrefMiddleName"} mandatory={false} />
                                <Input type="select" inputLabel={"Preferred Suffix"} identifier={"studentPrefSuffix"} mandatory={false} options={createList(staticData, "suffix")} />
                            </Row>
                        }
                        <Row>
                            <Input type="date" inputLabel={"Date of Birth"} identifier={"dateOfBirth"} maxDate={minDOB}></Input>
                            <Input type="select" inputLabel={"Gender"} identifier={"studentGender"} options={createList(staticData, "gender")}></Input>
                        </Row>
                    </Section>
                    <hr />
                    <Section title={"Contact Information"}>
                        <Row>
                            <Input type="phone" identifier={"studentHomePhone"} inputLabel={"Student Home Phone"}></Input>
                            <Input type="phone" identifier={"studentCellPhone"} inputLabel={"Student Cell Phone"} mandatory={false}></Input>
                        </Row>
                        <Input type="text" identifier={"studentEmail"} inputLabel={"Student Email"} mandatory={false} hint={"(Required for MyCred Personal Email)"}></Input>
                    </Section>
                    <hr />
                    <Section title={"Mailing Address"}>
                        <i>(Enter information in at least one (1) of the four (4) fields below as applicble)</i>
                        <Row>
                            <Input type="text" inputLabel="Box #" identifier="mailingBoxNo" mandatory={false}></Input>
                            <Input type="text" inputLabel="RR #" identifier="mailingRrNo" mandatory={false}></Input>
                        </Row>
                        <Row>
                            <Input type="text" inputLabel="Apartment #" identifier="mailingAptNo" mandatory={false}></Input>
                            <Input type="text" inputLabel="House #" identifier="mailingHouseNo" mandatory={false}></Input>
                        </Row>
                        <Input type="text" inputLabel={<>{"Street"} <i>(mandatory only if a house number was entered above.)</i></>} identifier="mailingStreet"
                            mandatory={(formData["mailingHouseNo"] && formData["mailingHouseNo"] !== "") ? true : false}></Input>
                        <Row>
                            <Input type="text" inputLabel="City" identifier="mailingCity"></Input>
                            <Input type="select" inputLabel="Province" identifier="mailingProvince" options={createList(staticData, "province")}></Input>
                            <Input type="text" inputLabel="Postal Code" identifier="mailingPostalCode"></Input>
                        </Row>
                    </Section>
                    <hr />
                    <Section title={"Physical Address"}>
                        <Input type="noyesradio" inputLabel="Is the student's physical address different from mailing address?" identifier="isPhysSameMailing" />
                        {formData["isPhysSameMailing"] === '1' &&
                            <>
                                <Row>
                                    <Input type="text" inputLabel="Apartment #" identifier="physAptNo" mandatory={false}></Input>
                                    <Input type="text" inputLabel="House #" identifier="physHouseNo" mandatory={false}></Input>
                                </Row>
                                <Input type="text" inputLabel="Street" identifier="physStreet" mandatory={false}></Input>
                                <Row>
                                    <Input type="text" inputLabel="City" identifier="physCity"></Input>
                                    <Input type="select" inputLabel="Province" identifier="physProvince" options={createList(staticData, "province")}></Input>
                                </Row>
                            </>
                        }
                        <Input type="noyesradio" inputLabel="Does the student live on an acreage or farm?" identifier="isOnAcreageFarm" />
                        {formData["isOnAcreageFarm"] === '1' &&
                            <>
                                <Row>
                                    <Input type="select" inputLabel="Quarter" identifier="physQuarter" options={createList(staticData, "quarter", { Disabled: "0" }, undefined, undefined, undefined, "Sort_Order")}></Input>
                                    <Input type="select" inputLabel="Section" identifier="physSection" options={createList(staticData, "section", { Disabled: "0" }, undefined, undefined, undefined, "Sort_Order")}></Input>
                                    <Input type="select" inputLabel="Township" identifier="physTownship" options={createList(staticData, "township", { Disabled: "0" }, undefined, undefined, undefined, "Sort_Order")}></Input>
                                </Row>
                                <Row>
                                    <Input type="select" inputLabel="Range" identifier="physRange" options={createList(staticData, "range", { Disabled: "0" }, undefined, undefined, undefined, "Sort_Order")}></Input>
                                    <Input type="select" inputLabel="Meridian" identifier="physMeridian" options={createList(staticData, "meridian", { Disabled: "0" }, undefined, undefined, undefined, "Sort_Order")}></Input>
                                </Row>
                            </>
                        }
                    </Section>
                    <hr />
                    <Section title={"Permanent or International Address"}>
                        <Input type="noyesradio" inputLabel="Does the student have an international or a permanent address different from their physical address?" identifier="hasPermInterAdd" />
                        {formData["hasPermInterAdd"] === '1' &&
                            <>
                                <Row>
                                    <Input type="text" inputLabel="Apartment #" identifier="permIntAptNo" mandatory={false}></Input>
                                    <Input type="text" inputLabel="House #" identifier="permIntHouseNo" mandatory={false}></Input>
                                </Row>
                                <Input type="text" inputLabel="Street" identifier="permIntStreet"></Input>
                                <Row>
                                    <Input type="text" inputLabel="City" identifier="permIntCity"></Input>
                                    <Input type="text" inputLabel="Province" identifier="permIntProvince"></Input>
                                    <Input type="select" inputLabel="Country" identifier="permIntCountry" options={createList(staticData, "countries")}></Input>
                                </Row>
                            </>
                        }
                    </Section>
                </>)}
        </Container>
    )
}